<template>
<v-container>
    <v-row>
      <v-col md="4">
        <v-checkbox :label="texto()" v-model="checkEmisor"></v-checkbox> 
      </v-col>
      <v-col v-if="checkEmisor" md="4">
          <v-text-field
            style="padding-top: 15px"
            v-model="nombreEmisor"
            name="Emisor-nombre"
            label="Nombre"
            dense
            @input="buscarEmisor()"
          >
          </v-text-field>
      </v-col>
        <v-col md="4" v-if="encontrados.length != 0">
          <v-card max-height="160" style="overflow: scroll" outlined tile>
              <v-list-item
                v-for="(entidad, index) in encontrados"
                :key="`encontrado-${index}`"
                @click="nuevoSeleccionado(entidad)"
              >
                <v-list-item-content>
                    <v-list-item-title>{{
                      entidad.responsable
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      entidad.nombre
                    }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{
                      entidad.cargo
                    }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
          </v-card>
        </v-col>
    </v-row>
</v-container>
</template>

<script>

export default {
  name: 'buscarEmisorEntidad',
  props: {
    tipo: { type: String, default: () => ""},
    entidades: { type: Array, default: () => []},
  },
  watch: {
    checkEmisor() {
      this.encontrados = [];
      this.nombreEmisor = "";
    }
  },
  data: () => ({
    checkEmisor: false,
    nombreEmisor: "",
    encontrados: []
  }),
  methods: {
    texto() {
      if (this.tipo === 'Entrante') return "Buscar por nombre de emisor";
      else if (this.tipo === 'Generado') return "Buscar por nombre de destinatario";
      else if (this.tipo === 'CPP') return "Buscar por nombre";
    },
    async buscarEmisor() {
      this.encontrados = [];
      if (this.nombreEmisor.length > 2) {
        try {
          const normalizar = (texto) => texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
          const regex = new RegExp(normalizar(this.nombreEmisor), "i");

          this.entidades.forEach((entidad) => {
            if (regex.test(normalizar(entidad.responsable))) {
              this.encontrados.push(entidad)
            }
          });
        } catch (error) {
          this.encontrados = [];
        }
      }
    },
    nuevoSeleccionado(entidad) {
      this.$emit('seleccionarEntidad', entidad);
    }
  }
}
</script>
